import { replaceLinksForDocument, replaceLinksForSite } from './assignment_compute';
const assignmentsPath = (entityId, studyId, environmentId) => `/v1/entities/${entityId}/studies/${studyId}/environments/${environmentId}/environment-site-consent-assignments`;
/**
 * PUTs the full set of `(siteId, templateKey)` rows for the environment (PUT semantics — full replace).
 * Unknown keys and duplicate pairs are dropped so a stale UI row cannot 400 the request.
 */
async function putAssignments(momClient, entityId, studyId, environmentId, assignments, consentFiles) {
    const knownKeys = new Set(consentFiles.map((file) => file.templateKey));
    const seen = new Set();
    const body = [];
    for (const a of assignments) {
        if (!knownKeys.has(a.consentTemplateKey)) {
            continue;
        }
        const dedupeKey = `${a.environmentSiteId}:${a.consentTemplateKey}`;
        if (seen.has(dedupeKey)) {
            continue;
        }
        seen.add(dedupeKey);
        body.push({ environmentSiteId: a.environmentSiteId, consentTemplateKey: a.consentTemplateKey });
    }
    await momClient.put(assignmentsPath(entityId, studyId, environmentId), { assignments: body });
}
export async function setAssignmentsForDocument(momClient, entityId, studyId, environmentId, assignments, consentTemplateKey, selectedEnvironmentSiteIds, environmentSites, consentFiles) {
    const nextAssignments = replaceLinksForDocument(assignments, consentTemplateKey, selectedEnvironmentSiteIds, environmentSites.map((site) => site.id));
    await putAssignments(momClient, entityId, studyId, environmentId, nextAssignments, consentFiles);
    return nextAssignments;
}
export async function setAssignmentsForSite(momClient, entityId, studyId, environmentId, assignments, environmentSiteId, selectedConsentTemplateKeys, consentTemplateKeysInScope, consentFiles) {
    const nextAssignments = replaceLinksForSite(assignments, environmentSiteId, selectedConsentTemplateKeys, consentTemplateKeysInScope);
    await putAssignments(momClient, entityId, studyId, environmentId, nextAssignments, consentFiles);
    return nextAssignments;
}
/**
 * Replaces every (site, template) assignment within the scoped environment via MOM.
 */
export async function replaceAllAssignments(momClient, entityId, studyId, environmentId, assignments, consentFiles) {
    await putAssignments(momClient, entityId, studyId, environmentId, assignments, consentFiles);
    return assignments;
}
